// Tracking Events
import { IntercomAPI } from "react-intercom";
import ReactPixel from "react-facebook-pixel";
import {
  trackPinterestEvent,
  trackQuoraEvent
} from "../../../utils/eventTracker";
import { trackAdsByRedux } from "../utm";
import { gaEvent } from "../trackEvents";

export const postUpgradeTrackingEvents = ({
  plan,
  subscriptionId,
  listing
}) => {
  let google_event_id;

  switch (plan.name) {
    case "Starter":
      // We no longer display annuals for Starter
      google_event_id = "AW-862529334/J6o4CLy2hLMBELbOpJsD";
      break;
    case "Professional":
      google_event_id = plan.annual
        ? "AW-862529334/3AZYCIPIo7QBELbOpJsD"
        : "AW-862529334/72jVCK_I5KIBELbOpJsD";
      break;
    case "Empire":
      google_event_id = plan.annual
        ? "AW-862529334/3okBCNrbsbQBELbOpJsD"
        : "AW-862529334/jqwKCKWY1KIBELbOpJsD";
      break;
    case "Unicorn":
      google_event_id = plan.annual
        ? "AW-862529334/feppCPmjnLUBELbOpJsD"
        : "AW-862529334/rYp8CMCjnLUBELbOpJsD";
      break;
    default:
      break;
  }

  // Conversion event to catch all "To Trials" on Google Ads
  window.gtag("event", "conversion", {
    send_to: "AW-862529334/CCy_CJ3wt9IBELbOpJsD",
    value: plan.price_exchanged_to_cad,
    currency: "CAD"
  });

  // Conversion event for specific plan "To Trial" on Google Ads
  window.gtag("event", "conversion", {
    send_to: google_event_id,
    value: plan.price_exchanged_to_cad,
    currency: "CAD",
    transaction_id: subscriptionId
  });

  // Google Analytics
  gaEvent({
    category: "Upgrade",
    action: "Start Trial",
    label: getGALabelStartTrial(listing)
  });

  gaEvent({
    category: "Upgrade",
    action: `Upgrade to ${plan.name} - ${plan.annual ? "Annual" : "Monthly"}`,
    label: getGALabelUpgrade(listing)
  });

  trackAdsByRedux({
    from: "google",
    category: "Upgrade",
    action: "StartTrialUTM"
  });

  trackAdsByRedux({
    from: "google",
    category: "Upgrade",
    action: `Upgrade to ${plan.name} - ${
      plan.annual ? "Annual" : "Monthly"
    } UTM`
  });

  // Facebook Pixel - conversion (StartTrial)
  ReactPixel.trackCustom(`StartTrial${plan.name}`);
  trackAdsByRedux({
    from: "facebook",
    action: `StartTrial${plan.name}UTM`
  });

  trackAdsByRedux({
    from: "facebook",
    action: "StartTrialUTM"
  });

  // Pinterest Pixel - conversion (StartTrial)
  trackPinterestEvent("checkout");

  // Quora Pixel - conversion (StartTrial)
  trackQuoraEvent("AddToCart");

  // Intercom
  IntercomAPI("trackEvent", `Plan Updated to ${plan.name}`);

  // ShareASale
  triggerShareASale({ plan, subscriptionId });
};

const triggerShareASale = ({ plan, subscriptionId }) => {
  try {
    if (plan !== undefined && subscriptionId) {
      let img = document.createElement("img");
      img.src = `https://www.shareasale.com/sale.cfm?tracking=${subscriptionId}&amount=${
        plan.price_plan
      }&merchantID=99321&transtype=sale`;
      document.head.appendChild(img);

      let script = document.createElement("script");
      script.setAttribute("src", "https://www.dwin1.com/19038.js");
      document.head.appendChild(script);
    }
  } catch (err) {
    console.log(err);
  }
};

const getGALabelStartTrial = listing => {
  // Users who created the account through our landing page
  const isLandingPageDirectSignUp = localStorage.getItem("landing_page_signup");

  if (isLandingPageDirectSignUp === "variant") {
    return "Email Signup Variant Start Trial";
  } else if (isLandingPageDirectSignUp === "control") {
    return "Email Signup Control Start Trial";
  } else if (isLandingPageDirectSignUp === "notIncluded") {
    return "Email Signup Not Included Start Trial";
  } else {
    if (listing === undefined) {
      return "";
    } else if (listing.premium === true) {
      return "Premium Start Trial";
    } else if (listing.premium === false) {
      return "Non-premium Start Trial";
    }
  }
};

const getGALabelUpgrade = listing => {
  // Users who created the account through our landing page
  const isLandingPageDirectSignUp = localStorage.getItem("landing_page_signup");

  if (isLandingPageDirectSignUp === "variant") {
    return "Email Signup Variant Upgrade";
  } else if (isLandingPageDirectSignUp === "control") {
    return "Email Signup Control Upgrade";
  } else if (isLandingPageDirectSignUp === "notIncluded") {
    return "Email Signup Not Included Upgrade";
  } else {
    if (listing === undefined) {
      return "";
    } else if (listing.premium === true) {
      return "Premium Upgrade";
    } else if (listing.premium === false) {
      return "Non-premium Upgrade";
    }
  }
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/trackingEvents/upgradeEvents.js